import { get } from "axios"

const getEquipment = (codigo) => {
    const token = localStorage.getItem('token');
    return (
        get(`${process.env.REACT_APP_URL_API}equipment/${codigo}`, {
            headers: {
                'Authorization': `Bearer ${token}`  // Incluye el token JWT en el encabezado
            }
        })
            .then(response => {
                const { data } = response
                return data
            })
            .catch(error => {
                console.log(error)
            })
    )
}
export default getEquipment
